export const supportedLocales = ['nl', 'en', 'de', 'fr'] as const
export type SupportedLocale = (typeof supportedLocales)[number]
